import React from "react";
import { Channel, Topic } from "../../../constants/index.js";
import { UserContextSelectors } from "../../../redux/selectors/index.js";
import { useDispatch, useSelector } from "react-redux";
import { Brand } from "../../../configurations/index.js";
import { Item } from "../Models/index.js";
import { LocalizationMessages } from "../../../localization/messages.js";
import { MenuActionCreators } from "../../../redux/action-creators/index.js";
import { MenuItem } from "../MenuItem.js";
import { MessageBrokerUtils } from "../../../utils/index.js";
import { BrandUtils } from "../../../utils/brandUtils.js";
import { MigrationUtils } from "../../../utils/migrationUtils.js";
import { useFeature } from "../../../hooks/index.js";
import { AppFeatures } from "../../../constants/featureFlags.js";

const RegisterOrDepositMenuItem = () => {
  const isNative = useSelector(UserContextSelectors.isNative);
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isEagleMigrationStarted = useFeature(AppFeatures.EAGLE_MIGRATION);
  const dispatch = useDispatch();

  const depositButtonClicked = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Quick_Deposit,
      headers: {
        publisher: "UAA"
      },
      data: {
        TabId: 16,
        Area: "Hamburger menu",
        Element: "Deposit button",
        Source: "Unified Client"
      }
    });
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const registerButtonClicked = () => {
    if (isEagleMigrationStarted && MigrationUtils.isSportRoMigrationOngoing()) {
      MigrationUtils.handleOpenRegistration(isNative);
    } else {
      MessageBrokerUtils.publish({
        channel: Channel.PLAYER,
        topic: Topic.CTA_NRS_Open,
        headers: {
          publisher: "UAA"
        }
      });
    }
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const getRegisterButton = () => {
    switch (brandId) {
      case Brand.Sport_Scasino:
      case Brand.Sport_Spoker: {
        return null;
      }
      case Brand.Sport_IT: {
        if (BrandUtils.isPokerClient()) return null;
      }
    }
    const registerItem = new Item({
      title: LocalizationMessages.registerButtonText,
      iconKey: "register"
    });

    return (
      <MenuItem
        item={registerItem}
        className="RegisterBtn"
        onClick={registerButtonClicked}
        dataTestId="uc-register"
      />
    );
  };

  const getDepositButton = () => {
    switch (brandId) {
      case Brand.Sport_Spoker: {
        return null;
      }
      default: {
        return (
          <MenuItem
            className="DepositBtn"
            onClick={depositButtonClicked}
            item={
              new Item({
                title: LocalizationMessages.deposit,
                iconKey: "deposit"
              })
            }
            dataTestId="uc-Cashier"
          />
        );
      }
    }
  };

  return isAuthenticated ? getDepositButton() : getRegisterButton();
};

export default React.memo(RegisterOrDepositMenuItem);
